






















import { Asset } from '@/js/Asset'
import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class BalanceRow extends Vue {
    @Prop() asset!: Asset
}
